export default __webpack_public_path__ + "static/media/language-rocketDAO-startup.01e12c88.svg";